import * as mutations from './../../mutation-types'

export const processNote = (store, item) => {
    if (item.files) {
        _.each(item.files, file => store.dispatch('processFile', file))
        delete(item.files)
    }

    if (item.actor) {
        item.actor_type === 'contact' ?
            store.dispatch('processContact', item.actor) :
            store.dispatch('processUser', item.actor)

        delete(item.actor)
    }

    item.is_milestone = item.is_milestone ? 1 : 0

    store.commit(mutations.ADD_OR_UPDATE_NOTE, item)
}

export const createNote = (store, item) => {
    return axios.post(`/api/notes`, item)
        .then(res => {
            processNote(store, res.data.data)
            return res
        })
}

export const  fetchNotesHistoryRecent10 = (store, projectServiceId) => {
        const params = {
            field: "notes",
            paginated: true,
            per_page: 10,
            reference_id: projectServiceId,
            reference_type: "project-service",
        }
        return axios.post(`/api/historical-data/list`, params).then(({ data: { data } }) => data)
}

export const updateNote = (store, item) => {
    return axios.patch(`/api/notes/${item.id}`, item)
        .then(res => {
            processNote(store, res.data.data)
            return res
        })
}

export const removeNote = (store, item) => {
    return axios.delete(`/api/notes/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_NOTE, item)
            return res
        })
}

export const resendNote = (store, {note, params}) => {
    return axios.get(`/api/notes/${note.id}/resend`, {params})
}

export const fetchNotesById = (store, id) => {
    return axios.get(`/api/notes/${id}`)
        .then(res => {
            processNote(store, res.data.data)
            return res
        })
}
